import styled from 'styled-components';

export const ProductsListHead = styled.div`
  display: flex;
  border: 1px solid transparent;
  border-bottom: '1px solid ${({ theme }) => theme.pantone656C}';
  font-size: 13px;
  font-weight: 700;
  @media (max-width: 1200px) {
    min-width: 847px;
  }
  .products-list__column {
    justify-content: center;
    border-right: 1px solid #ebebeb;
    &:last-child {
      border: none;
    }
  }
`;

